import { useHistory } from 'react-router-dom';
import { BIPOLAR } from 'components/shared/types';
import MailingList from 'components/assessment-email';
import { BIPOLAR_ASSESSMENT_RESULT } from 'constants/localStorageKey';

const BipolarEmail = (): JSX.Element => {
  const history = useHistory();
  const data = localStorage.getItem(BIPOLAR_ASSESSMENT_RESULT);

  const handleNextPage = () => {
    history.push('/bipolar-assessment-result');
  };

  if (!data) {
    history.push('/bipolar-self-test');
    return <></>;
  }

  return <MailingList handleNextPage={handleNextPage} condition={BIPOLAR} />;
};

export default BipolarEmail;
